import { TokenResponse } from "types/TokenResponse";
import { createCustomAction, createAction } from "typesafe-actions";

const OIDC_DATA_LOAD = "OIDC/OIDC_DATA_LOAD";
const OIDC_DATA_LOAD_SUCCESS = "OIDC/OIDC_DATA_LOAD_SUCCESS";
const OIDC_DATA_LOAD_FAIL = "OIDC/OIDC_DATA_LOAD_FAIL";
const OIDC_DATA_EMPTY = "OIDC/OIDC_DATA_EMPTY";

export const load = createAction(OIDC_DATA_LOAD);

export const loadSuccess = createCustomAction(
  OIDC_DATA_LOAD_SUCCESS,
  (type) => (data?: TokenResponse) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(OIDC_DATA_LOAD_FAIL, (type) => (error?: string) => ({
  type,
  error,
}));

export const empty = createAction(OIDC_DATA_EMPTY);
